<template>
    <div>
        <div class="max-w-1140px m-auto"
            :class="[{'flex justify-center': !isOverflow && isInitOverflow }]">
            <div class="splide" id="cate-home-main">
                <div class="splide__track">
                    <ul ref="test" class="splide__list">
                        <li class="splide__slide"
                            v-for="(cate, k) in cateList"
                            :key="k"
                            @click="clickCate(cate)">
                            <div class="cursor-pointer border-b-4 pb-1 w-20" :class="[isActiveCate(cate) ? 'border-a-red-d62300' : 'border-transparent']">
                                <div>
                                    <img v-if="isActiveCate(cate)" class="h-6 lg:h-10 m-auto" :src="cate.imageActive">
                                    <img v-else class="h-6 lg:h-10 m-auto" :src="cate.imageInactive">
                                </div>
                                <div class="mt-2 h-11 text-center text-14 lg:text-16 font-bold" :class="[getClassCateName(cate)]">
                                    {{getCateName(cate)}}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="line-cate bg-a-brown-d7c7b8 h-1px w-full"></div>
    </div>
</template>
<script>

//library
import Splide from '@splidejs/splide'; //https://splidejs.com/

//helper
// import Util from '@/helper/Utility.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    mixins: [LocaleMixin,],
    props: {
        cateList: { type: Array, required: true },
        selectedCat: { type: Object, default: null },
    },
    data: function () {
        return {
            slider: null,
            activeCateId: null,
            isOverflow: false,
            isInitOverflow: false,
        };
    },
    watch: {
        selectedCat: function () {
            this.setActiveIndex();
        },
    },
    mounted: function () {
        this.setActiveIndex();
        this.initSlider();
    },
    methods: {
        //#region init
        initSlider: function () {
            this.$nextTick(() => {
                let currentIndex = this.getCurrentIndex();
                this.slider = new Splide('#cate-home-main', {
                    arrows: false,
                    pagination: false,
                    autoWidth: true,
                    gap: 25,
                    padding: 0,
                    start: currentIndex,
                    breakpoints: {
                        1024: {
                            padding: 16,
                        },
                    },
                }).mount();
               
                this.checkOverflow()
                this.slider.on( 'resize', () => {
                    this.checkOverflow()
                });
                //this.slider.mounted();
                // this.slider.on('move', (newIndex) => {
                //     this.currentSliderIndex = newIndex;
                // });
            });
        },

        checkOverflow: function () {
            setTimeout(() => {
                this.isInitOverflow = false;
                this.isOverflow = false;

                let listEl = this.$refs['test'] ? this.$refs['test'].getElementsByTagName('li') : []
                listEl.forEach(element => {
                    console.log('element', element.getAttribute('aria-hidden'));
                    if (element.getAttribute('aria-hidden')) {
                        this.isOverflow = true
                    }
                });
                this.isInitOverflow = true;
                console.log('isOverflow', this.isOverflow);
            },300);           
        },

        getCurrentIndex: function () {
            let found = 0;
            for (let i in this.cateList) {
                if (this.cateList[i].id == this.activeCateId) {
                    found = i;
                    break;
                }
            }
            return found;
        },
        setActiveIndex: function () {
            if (this.selectedCat != null) {
                this.activeCateId = this.selectedCat.id;
            } else {
                this.activeCateId = null;
            }
        },
        //#endregion init

        //#region render
        isActiveCate: function (cate) {
            return this.activeCateId == cate.id;
        },
        getClassCateName: function (cate) {
            if (this.isActiveCate(cate)) {
                return 'text-a-red-d62300';
            }
            return 'text-a-brown-502314';
        },
        //#endregion render


        clickCate: function (cate) {
            // console.log('clickCate', cate);
            this.tracking.event('homepage','click_category_menu', `click_${cate.nameEn}`, null);
            this.$router.replace({
                name: 'home',
                params: { catId: cate.id },
            });
            // this.$emit('onClickCate', cate);
        },
        getCateName: function (cate) {
            return this.localeCode == 1033 ? cate.nameEn : cate.nameTh;
        },
    },
}
</script>
<style lang="scss" scoped>
    .line-cate {
        margin-top: -1px;
    }
</style>

